import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { finalize, map } from 'rxjs/operators';

import { format, parse } from 'date-fns';

import {
  DOBFormComponent, DOBFormModel
} from 'entity/forms/dob-form/dob-form.component';

import {
  EntityTypeDetails, GetEntityById2GQL, UpdateEntityBasicInfoGQL
} from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface AddOrUpdateDOBDialogData {
  entityId: string;
  campaignId: string;
}

@Component({
  selector: 'app-add-or-update-dob',
  templateUrl: './add-or-update-dob.dialog.html'
})
export class AddOrUpdateDOBDialog implements OnInit {
  isSaving = false;

  /**
   * Set by dumb form component
   */
  formControl: UntypedFormControl;

  entityType: EntityTypeDetails.Fragment;

  static open(dialog: MatDialog, config: MatDialogConfig<AddOrUpdateDOBDialogData>) {
    return dialog.open(AddOrUpdateDOBDialog, config);
  }
  constructor(
    private _getEntityById2GQL: GetEntityById2GQL,
    private _updateEntityBasicInfoGQL: UpdateEntityBasicInfoGQL,
    public dialogRef: MatDialogRef<AddOrUpdateDOBDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddOrUpdateDOBDialogData
  ) { }

  ngOnInit(): void {
    this._getDataAndBuildForm();
  }

  onSaveClicked() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this._save$().pipe(
      finalize(() => this.isSaving = false)
    ).subscribe(({ data }) => {
      this.close(data.updateEntity);
    });
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }

  private _getDataAndBuildForm() {
    this._getEntityById2GQL.fetch({
      entityId: this.data.entityId,
      campaignId: this.data.campaignId
    }).pipe(
      map(({ data }) => data.getEntity)
    ).subscribe((entity) => {
      this.entityType = entity.entityType;
      this.formControl = new UntypedFormControl(
        DOBFormComponent.toFormModel(entity)
      );
    });
  }

  private _save$() {
    const fv: DOBFormModel = this.formControl.value;

    const age = fv.dateOfBirth ? undefined : fv.age ? parseInt(fv.age.toString(), 10) : undefined;

    return this._updateEntityBasicInfoGQL.mutate({
      input: {
        entityId: this.data.entityId,
        campaignId: this.data.campaignId,
        changes: {
          age: age || null,
          dateOfBirth: fv.dateOfBirth ? format(parse(fv.dateOfBirth, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd') : null
        }
      }
    });
  }
}
